$(function() {
  $('#cart_submit_button').on('click', function() {
    $('#cart_submit_modal').addClass('show_modal');
    $('#get_consent_modal').addClass('show_modal');
    $('.page-container').addClass('show_modal');
    console.log('1');
  });
  $('#cart_submit_agree').on('click', function() {
    $('#payment_modal').addClass('show_modal');
    $('#get_consent_modal').removeClass('show_modal');
    console.log('2');
  });
  $('#cart_submit_disagree').on('click', function() {
    $('#cart_submit_modal').removeClass('show_modal');
    $('#get_consent_modal').removeClass('show_modal');
    $('.page-container').removeClass('show_modal');
    console.log('3');
  });
  $('#cart_submit_modal').on('click', function() {
    $('#cart_submit_modal').removeClass('show_modal');
    $('#get_consent_modal').removeClass('show_modal');
    $('#payment_modal').removeClass('show_modal');
    console.log('4');
  });
  $('#nav_button_wrap').on('click', function() {
    $('#nav_button').toggleClass('active');
    $('#main_link_list').toggleClass('active');
  });
  
});

// スライダー
$(function(){
  var imageId = 1;
  var imageList = $("#top_image_list"),
      prev = $("#prev"),
      next = $("#next");
  
  function switchToNextImage() {
        if (imageId == 4) {
          imageId  = 1;
          fadeImage();
        } else {
          imageId++;
          fadeImage();
        }
  }
  
  function switchToPrevImage() {
      if (imageId == 1) {
          imageId = 4;
          fadeImage();
      } else {
        imageId --;
        fadeImage();
      }
  }
  
  var autoSlide = setInterval(switchToNextImage, 4000);
  
  prev.click(function(){ switchToPrevImage(); });
  next.click(function(){ switchToNextImage(); });
  
  function fadeImage() {
    imageList.children(".top_image").fadeOut();
    imageList.children(".top_image").eq(imageId - 1).fadeIn("slow");
      clearInterval(autoSlide);
      autoSlide = setInterval(switchToNextImage, 4000);
  }
  
  
  
  });